/**
 * PartyCard — F-003.2 Phase 3 (IMPL-P3-002).
 *
 * Card wrapper shadcn per i dati di una parte contrattuale (locatore o conduttore).
 * Il prefix determina quale field group viene montato; il title è passato
 * come prop per flessibilità futura.
 *
 * NON usa useFieldArray (locatore e conduttore sono oggetti singoli, non array).
 * Thin wrapper — nessuna logica RHF propria: i field components consumano
 * `useFormContext` direttamente.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LocatoreFields } from '../fields/LocatoreFields';
import { ConduttoreFields } from '../fields/ConduttoreFields';

export interface PartyCardProps {
  prefix: 'locatore' | 'conduttore';
  title: string;
  showTooltips?: boolean;
}

export function PartyCard({ prefix, title, showTooltips = false }: PartyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {prefix === 'locatore' ? (
          <LocatoreFields showTooltips={showTooltips} />
        ) : (
          <ConduttoreFields showTooltips={showTooltips} />
        )}
      </CardContent>
    </Card>
  );
}
